import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class AngularModalService {

  constructor(private bsModalService: BsModalService) {
    // ngx-bootstrap strips modal-open from body whenever a stacked modal closes, which breaks
    // the layout and scrolling of the modal still open underneath it.
    this.bsModalService.onHidden.subscribe(() => {
      if (this.isAnyModalOpen()) {
        $('body').addClass('modal-open');
      }
    });
  }

  isAnyModalOpen() {
    return $('.modal.in, .modal.show').length > 0;
  }

  addModalOpenClassToBodyIfAnyModalIsOpen() {
    // add back modal-open class to body to enable scrolling of the modal,
    // but only when a modal is actually still open - otherwise this leaves
    // body stuck with overflow:hidden (no scrollbar) after the last modal closes
    setTimeout(() => {
      if (this.isAnyModalOpen()) {
        $('body').addClass('modal-open');
      }
    }, 500);
  }

  closeAllOpenModals() {
    while (this.bsModalService.getModalsCount() > 0) {
      this.bsModalService.hide(this.bsModalService.getModalsCount());
    }
  }
}
